import {useReducer} from "react";
import "./form.scss";
import {withLanguage, withDictionary} from "../../assets/js/contexts";
import {useLang} from "../../helpers/language";

const OtherForm = ({contactLabels, tab,formik,sent}) => {
    const {lang} = useLang();

    return (
        <div id="otherform"
            className={
                `tabform ${
                    !tab ? "d-none" : ""
                }`
        }>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-control" data-icon="person">
                        <input
                            type='text'
                            placeholder={contactLabels.name[lang]}
                            onChange={formik.handleChange}
                            name="name"
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                            className={`${formik.touched.name && !!formik.errors.name && 'border-danger'}`}
						/>
						<i />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-control" data-icon="email">
                        <input
								type='text'
								placeholder={contactLabels.email[lang]}
								onChange={formik.handleChange}
								name="email"
								onBlur={formik.handleBlur}
								value={formik.values.email}
								className={`${formik.touched.email && !!formik.errors.email && 'border-danger'}`}
							/>
                        <i/>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-control">
                    <input
								type='text'
								placeholder={contactLabels.title[lang]}
								onChange={formik.handleChange}
								name="subject"
								onBlur={formik.handleBlur}
								value={formik.values.subject}
								className={`${formik.touched.subject && !!formik.errors.subject && 'border-danger'}`}
							/>
                    </div>
                </div>
            </div>
            <div className="form-control">
            <textarea
						placeholder={contactLabels.message[lang]}
						rows='5'
						onChange={formik.handleChange}
						name="description"
						onBlur={formik.handleBlur}
						value={formik.values.description}
						className={`${formik.touched.description && !!formik.errors.description && 'border-danger'}`}
					/>
            </div>
            <div className="d-flex justify-content-center buttons"
                style={
                    {marginTop: 9}
            }>
                <button className="round black"
                    onClick={formik.handleSubmit} aria-label="round back">
                    {
                    contactLabels.button[lang]
                } </button>
            </div>
        </div>
    );
};

export default withLanguage(withDictionary(OtherForm));
